// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__mEH2h"};